import { styled } from '@material-ui/core/styles'
import defaults from '@config/defaults'

export const Hero = styled('div')(({ theme, image }) => {
  return ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: theme.palette.common.white,
    height: `calc(100vh - ${defaults.redesignHeaderHeight * 3}px)`,
    backgroundImage: `url(${image}?h=900&w=400&fit=fill&fl=progressive&q=80)`,
    padding: `0 ${theme.spacing(2)}px`,
    [theme.breakpoints.up('md')]: {
      height: 600,
      backgroundImage: `url(${image}?h=700&w=1400&fit=fill&fl=progressive&q=80)`,
    },
    [theme.breakpoints.up('lg')]: {
      height: 700,
    },
  })
})
